<template>
  <div :class="b()">
    <span itemprop="brand" itemtype="https://schema.org/Brand" itemscope>
      <meta itemprop="name" :content="brand" />
      <span :class="b('brand')">{{ brand }}</span>
    </span>

    <span :class="b('name')"> {{ name }} </span>
    <meta itemprop="name" :content="name" />
  </div>
</template>

<script src="./name.scripts.js" />

<style module src="./name.styles.scss" lang="scss" />
